/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
//
// THIS IS A GENERATED FILE
// DO NOT MODIFY IT! YOUR CHANGES WILL BE LOST
import { InjectionToken } from '@angular/core';

/**
 * Specific GrpcClientSettings for IdentityEndpoint.
 * Use it only if your default settings are not set or the service requires other settings.
 */
export const GRPC_IDENTITY_ENDPOINT_CLIENT_SETTINGS = new InjectionToken<any>(
  'GRPC_IDENTITY_ENDPOINT_CLIENT_SETTINGS'
);

/**
 * Specific GrpcClientSettings for CustomerAssetsEndpoint.
 * Use it only if your default settings are not set or the service requires other settings.
 */
export const GRPC_CUSTOMER_ASSETS_ENDPOINT_CLIENT_SETTINGS = new InjectionToken<
  any
>('GRPC_CUSTOMER_ASSETS_ENDPOINT_CLIENT_SETTINGS');

/**
 * Specific GrpcClientSettings for LoggerEndpoint.
 * Use it only if your default settings are not set or the service requires other settings.
 */
export const GRPC_LOGGER_ENDPOINT_CLIENT_SETTINGS = new InjectionToken<any>(
  'GRPC_LOGGER_ENDPOINT_CLIENT_SETTINGS'
);

/**
 * Specific GrpcClientSettings for SubscriptionEndpoint.
 * Use it only if your default settings are not set or the service requires other settings.
 */
export const GRPC_SUBSCRIPTION_ENDPOINT_CLIENT_SETTINGS = new InjectionToken<
  any
>('GRPC_SUBSCRIPTION_ENDPOINT_CLIENT_SETTINGS');

/**
 * Specific GrpcClientSettings for SmartChargeEndpoint.
 * Use it only if your default settings are not set or the service requires other settings.
 */
export const GRPC_SMART_CHARGE_ENDPOINT_CLIENT_SETTINGS = new InjectionToken<
  any
>('GRPC_SMART_CHARGE_ENDPOINT_CLIENT_SETTINGS');

/**
 * Specific GrpcClientSettings for AdminPowerPriceEndpoint.
 * Use it only if your default settings are not set or the service requires other settings.
 */
export const GRPC_ADMIN_POWER_PRICE_ENDPOINT_CLIENT_SETTINGS = new InjectionToken<
  any
>('GRPC_ADMIN_POWER_PRICE_ENDPOINT_CLIENT_SETTINGS');

/**
 * Specific GrpcClientSettings for ReportServiceEndpoint.
 * Use it only if your default settings are not set or the service requires other settings.
 */
export const GRPC_REPORT_SERVICE_ENDPOINT_CLIENT_SETTINGS = new InjectionToken<
  any
>('GRPC_REPORT_SERVICE_ENDPOINT_CLIENT_SETTINGS');
